import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Footer, Navbar } from "../../components/PublicLayout";

export const Route = createFileRoute("/(public)")({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
